import { Routes, Route, Navigate } from 'react-router';

import ChangePasswordPage from '@/pages/ChangePasswordPage';
import useLanguage from '@/hooks/useLanguage';

const App = () => {
  useLanguage();

  return (
    <Routes>
      <Route path="/" element={<ChangePasswordPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
